import React, { useState } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import styles from 'styles';

const HtmlContent = ({ letter }) => {
    const [state, setState] = useState({
        isOpenDialog: false,
    });

    const toggleDialog = () => {
        setState(prevState => ({
            ...prevState,
            isOpenDialog: !prevState.isOpenDialog,
        }));
    };

    const actions = [
        <FlatButton
            label='CLOSE'
            primary
            onClick={toggleDialog}
        />,
    ];

    return (
        <div className="btn">
            <RaisedButton
                onClick={toggleDialog}
                disabled={!letter.html}
                label='HTML'
                labelStyle={{ fontSize: '10px' }}
                style={{ height: '25px' }}
                buttonStyle={{ height: '25px', lineHeight: '25px' }}
                primary
            />

            <Dialog
                title='HTML'
                actions={actions}
                modal={false}
                contentStyle={styles.Dialog}
                open={state.isOpenDialog}
                onRequestClose={toggleDialog}
            >
                {/* sandbox should be an empty string to prevent errors in console */}
                <iframe
                    title="HTML Content"
                    srcDoc={letter.html}
                    sandbox=""
                    style={{
                        overflow: 'auto',
                        border: 'none',
                        width: '100%',
                        height: '65vh',
                    }}
                    frameBorder="0"
                />
            </Dialog>
        </div>
    );
};

export default HtmlContent;



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/HtmlContent.jsx